import type { BonPrintContext } from 'shared-models/browser';

export const PINNED_BON_PRINTER_STORAGE_KEY = 'posPinnedBonPrinterId';

export function getPinnedBonPrinterId(): number | null {
  const raw = localStorage.getItem(PINNED_BON_PRINTER_STORAGE_KEY);
  if (!raw) return null;
  const parsed = Number(raw);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}

export function setPinnedBonPrinterId(printerId: number): void {
  localStorage.setItem(PINNED_BON_PRINTER_STORAGE_KEY, String(printerId));
}

export function clearPinnedBonPrinterId(): void {
  localStorage.removeItem(PINNED_BON_PRINTER_STORAGE_KEY);
}

export function getBonPrintContext(): BonPrintContext {
  return { suppressedBonPrinterId: getPinnedBonPrinterId() };
}

export function withoutPinnedBonRoutes<T extends { printerId: number }>(routes: T[]): T[] {
  const pinnedPrinterId = getPinnedBonPrinterId();
  return pinnedPrinterId == null ? routes : routes.filter((route) => route.printerId !== pinnedPrinterId);
}